<template>
    <div class="w-100 text-small">
      <v-breadcrumbs 
        itemscope 
        itemtype="https://schema.org/BreadcrumbList" 
        :items="items" 
        class="my-0 py-2 breadscroll" 
        bg-color="primary" 
        divider="/">
        <template v-slot:prepend>
          <v-icon size="small" icon="mdi-home"></v-icon>
        </template>
        <template v-slot:divider>
          /
        </template>
        <template v-slot:item="{ item, index }">
          <v-breadcrumbs-item
            :icon="item.icon"
            class="crumb"
            exact
            :position="index+1"
            itemprop="itemListElement" 
            itemscope
            :itemid="item.href"
            :id="item.href"
            :title="removeSeparator(item.title)"
            itemtype="https://schema.org/ListItem"
            :to="item.href"
            :href="item.href"
            >
            <span
            itemscope 
            itemtype="https://schema.org/WebPage"
            itemprop="item" 
            :itemid="item.href"
            :id="item.href"
            class="v-breadcrumbs-item--link"
            aria-current="page"
            >
            <span itemprop="name"> {{ removeSeparator(item.title) }}</span>
           </span>
           <meta itemprop="position" :content="index+1" />
          </v-breadcrumbs-item>
        </template>
        

      </v-breadcrumbs>
      <v-progress-linear :height="(loading) ? 4 : 0" :v-if="loading" :indeterminate="loading">
      </v-progress-linear>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
        }),
    },
    props:{
      page :{
        required: false
      }
    },
    data: () => ({
      items: [],
    }),
    mounted(){
      this.items = this.getDefItems()
      if(this.page){
       this.items = this.getValidItems(this.page)
      }
    },
    methods:{
      removeSeparator(title){
          return title.replace("| Primerent", '');
      },
      getValidItems(page){
        var items = [];

        var homeRoute = {
          title: 'Home',
          icon: 'mdi-home',
          href: '/',
          disabled: false,
        }

        items.push(homeRoute)

        if(page.parent){

          var parentRoute = {
            title: page.parent.title,
            href: page.parent.full_slug,
            disabled: false,
          }

          if(page.parent.parent){

            var parentParentRoute = {
              title: page.parent.parent.title,
              href: page.parent.parent.full_slug,
              disabled: false,
            }
            items.push(parentParentRoute)

          }

          items.push(parentRoute)
        }

        var pageRoute = {
          title: page.title,
          href: page.full_slug,
          disabled: false,
        }

        items.push(pageRoute)

        return items
      },
      getDefItems(){
            var items = [];
            var routes = this.$route.fullPath.split('/');

            routes.forEach((element,i) => {
                var route = {}
                if(i == 0){
                  route = {
                    title: 'Home',
                    href: '/',
                    disabled: false,
                  }
                  items.push(route)
                }else if(i == (routes.length-1)){
                  route = {
                    title: element,
                    href: this.$route.fullPath,
                    disabled: true,
                  }
                  items.push(route)
                }else{
                  var previousRoute = routes.slice(0,i);
                  var link = previousRoute.join('/')+'/'+element
                  route = {
                    title: element,
                    href: link,
                    disabled: false,
                  }
                  items.push(route)
                }

            });
            return items
        },
    }
  }
</script>

<style scoped>



.crumb {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>